<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.35 26.74">
    <g id="icnlater_1" data-name="icnlater_1">
      <g id="icnlater_2" data-name="icnlater_2">
        <path class="cls-1" :class="group1.gaClass" d="M67.15,10.93a2.11,2.11,0,0,0-2.81-1l-2.48,1.18A13.36,13.36,0,0,0,35.8,9.87a8.83,8.83,0,0,0-1.95-.22,8.54,8.54,0,0,0-2.24.3A13.36,13.36,0,0,0,5.53,11.09L2.93,10a2.11,2.11,0,1,0-1.64,3.88l4.16,1.76s.06,0,.08,0A13.36,13.36,0,0,0,32,14a4.35,4.35,0,0,1,1.82-.37,4.57,4.57,0,0,1,1.5.24,13.36,13.36,0,0,0,26.49,1.87,1,1,0,0,0,.23-.08l4.08-1.94A2.12,2.12,0,0,0,67.15,10.93ZM18.7,22.74a9.37,9.37,0,1,1,9.36-9.37A9.38,9.38,0,0,1,18.7,22.74Zm30,0a9.38,9.38,0,0,1-9.37-9.37c0-.34,0-.67.05-1l.2-.12-.15-.19A9.36,9.36,0,1,1,48.7,22.74Z"/>
      </g>
    </g>
  </svg>
</template>

<script>
import { defineComponent, reactive, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    // GA計測用class名
    gaClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup (props, context) {

    const group1 = reactive({
      gaClass: computed(() => {
        return props.gaClass
      })
    })

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
svg {
  width: 24px;
  height: 16px;
}
</style>
